import { render, staticRenderFns } from "./FieldsetContractNumbersData.yaml?vue&type=template&id=f2445f8e&component"
import script from "./FieldsetContractNumbersData.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetContractNumbersData.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports